module.exports = __webpack_public_path__ + "img/zt-img2.f16bd5a2.png";